// Switch reutilizável (Ativo/Inativo ou qualquer on/off)
export function StatusSwitch({
  value,
  onChange,
  labelOn  = 'Ativo',
  labelOff = 'Inativo',
  colorOn  = '#198754',
  colorOff = '#adb5bd',
}) {
  return (
    <div className="d-flex align-items-center gap-2">
      <span className="small fw-bold" style={{ color: value ? colorOn : colorOff }}>
        {value ? labelOn : labelOff}
      </span>
      <div
        onClick={() => onChange(!value)}
        title={value ? `Clique para ${labelOff.toLowerCase()}` : `Clique para ${labelOn.toLowerCase()}`}
        style={{
          width: '44px', height: '24px', borderRadius: '999px',
          backgroundColor: value ? colorOn : colorOff,
          cursor: 'pointer', position: 'relative',
          transition: 'background-color 0.25s', flexShrink: 0,
        }}
      >
        <div style={{
          width: '18px', height: '18px', borderRadius: '50%',
          backgroundColor: '#fff', position: 'absolute',
          top: '3px', left: value ? '23px' : '3px',
          transition: 'left 0.25s',
          boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
        }} />
      </div>
    </div>
  );
}
